var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoePrints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 1c-3.687 0-5 2.583-5 5 0 .503.03 3.075.619 4.305.293.61.381.794.381 1.695 0 4.132 2.175 5 4 5 2.654 0 4-1.682 4-5 0-.915.208-1.539.448-2.261.259-.775.552-1.654.552-2.893 0-1.446 0-5.846-5-5.846zm0 2c2.243 0 3 .971 3 3.846 0 .915-.208 1.539-.448 2.261-.094.28-.191.574-.278.893h-4.599c-.071-.175-.154-.356-.252-.56-.237-.495-.423-2.006-.423-3.44 0-1.369.521-3 3-3zm0 12c-1.012 0-2-.231-2-3h4c0 2.769-.988 3-2 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18 7c-5 0-5 4.4-5 5.846 0 1.239.293 2.118.552 2.893.24.722.448 1.346.448 2.261 0 3.318 1.346 5 4 5 1.825 0 4-.868 4-5 0-.901.088-1.085.38-1.694.59-1.23.62-3.803.62-4.306 0-2.417-1.313-5-5-5zm0 2c2.479 0 3 1.631 3 3 0 1.435-.186 2.946-.424 3.441-.097.203-.18.384-.251.559h-4.598c-.087-.319-.185-.613-.278-.893-.24-.722-.448-1.346-.448-2.261 0-2.875.757-3.846 3-3.846zm0 12c-1.012 0-2-.231-2-3h4c0 2.769-.988 3-2 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoePrints);
export default __webpack_public_path__ + "static/media/shoe-prints.41798ddebe9767c746a2f3d927ab712e.svg";
export { ForwardRef as ReactComponent };